'use strict';

const uuid = require('uuid');
const _ = {
    cloneDeep:  require('lodash/cloneDeep'),
    forEach:    require('lodash/forEach'),
};

const AssetUtil = require('./asset');

const api =  {
    // needed for react-mzl RichTextEditor
    getAppForSharedComponents: function(params) {
        var { course_hash, getDoc } = params;
        // let tableHelper = new TableHelper(getDoc);
        
        const dummyFunction = ()=>{};
        
        const ReactMzlActions = {
            openConfirmDialog: (title,confirmText, buttonText, onConfirm)=>{
                if (window.confirm(`${title}: ${confirmText}`)) {
                    onConfirm();
                }
            },
            onMouseOverHelpHandler: dummyFunction,
            changeAttribution: dummyFunction,
        };

        return {
            Actions: ReactMzlActions,
            getStaticData: ()=>(
                {
                    attributionSys: {
                        active: false 
                    },
                    a11ySys: {
                        data: {},
                    },
                }),
            resolveAssetPath: AssetUtil.resolveAssetPathEverywhere,
            buildFullVariableTable: ()=>({}),
            decodeExpression: (value,vt)=>(value),
            encodeExpression: (richText,variableTable)=>(richText),
            
            ASSET_PREFIX: GlobalConfig.AssetStoreUrl,
            generateUniqueRTImageID: function() {
                let img_id = uuid.v4();
                return `rt_image_${img_id}`;
            },

            subscribe: function() { return dummyFunction; }, // dummy subscribe
            subscribeSave: function() { return dummyFunction; }, // TODO: implement this so rich text editor can save when the top bar save button is pressed
//            subscribeSave: (func)=>{
//                EditorStore.getEmitter().on('save-rte',func);
//                return ()=>{
//                    EditorStore.getEmitter().removeListener('save-rte',func);
//                }
//            },
            
            setA11yData: dummyFunction, // TODO forge a11ySys

            VIDEO_PLAYER_TYPES: { youtube: 'youtube', vimeo: 'vimeo' }, 
            
            // used by react-mzl SingleAssetInput
            FORGE_URL: '',
            ACTIVITY_ID: `course_hash ${course_hash}`, // TODO: update react-mzl SingleAssetInput for use within forge short courses
            
            genElemId: function() { // needed for TextStylerToolbar
                return 'elem-' + uuid.v4();
            },
        };
    } // getAppForSharedComponents
    
}

module.exports = api;